export default __webpack_public_path__ + "static/media/glasses.31206581.jpg";